// Built-in imports
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

// Internal imports
import { Label, Value } from "./counter.styles";
import sectionWrapper from "../../hoc/sction-wrapper.component";
import { fadeIn } from "../../utils/motion/motion.utils";

const Counter = ({ traget, label, timeOut }) => {
  const [client, setClients] = useState(0);

  useEffect(() => {
    if (client < traget) counter();
  }, [client, traget]);

  const counter = () => {
    setTimeout(
      () => {
        setClients(client + 1);
      },
      timeOut,
      traget
    );
  };

  return (
    <div>
      <Value>{client}+</Value>
      <Label>{label}</Label>
    </div>
  );
};
export default sectionWrapper(Counter);
